import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Freshness > perf. USM data changes across devices constantly
      // (multi-terminal store), so we prefer a cheap refetch over
      // showing stale numbers. Backend already sends `Cache-Control:
      // no-store` and the ingress reports `cf-cache-status: DYNAMIC`,
      // so a refetch is a single ~50 ms round-trip.
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
